<template>
	<div class="sf-flex-column">
		<!-- ContentView 검색조건 영역 시작 -->
		<div class="sf-col sf-col-4">
			<sf-card class="p-0 card_bg">
				<search-view :scrId="scrId" @PopupOpen="PopupOpen" @PqPartPopupOpen="PqPartPopupOpen" />
			</sf-card>
		</div>
		<!-- ContentView 검색조건 영역 종료 -->
		<!-- ContentView 테이블 영역 시작 -->
		<div class="sf-col sf-col-20">
			<table-view :scrId="scrId" />
		</div>
		<!-- ContentView 테이블 영역 종료 -->

		<!-- 팝업부분 영역 시작 -->
		<user-popup-view ref="userPopupView" @SendData="sendData" @Refresh="Refresh" :scrId="scrId" />
		<part-mng-popup ref="partMngPopup" @SendData="sendData" @Refresh="Refresh2" :scrId="scrId" />
		<!-- 팝업부분 영역 종료 -->
	</div>
</template>

<script>
import UserPopupView from '../../comm/commpopup/UserPopup/UserPopupView.vue';
// import pqPartPopup from '@qms/comm/PqPartPopup/PqPartPopup.vue';
import partMngPopup from '@qms/comm/commpopup/PartMngPopup/PartMngPopup.vue';
import SearchView from './Search/SearchView.vue';
import TableView from './Table/TableView.vue';

export default {
	props: {
		scrId: { type: String, default: '' }
		// , userName: { type: String, default: '' }
	},
	//	components: { SearchView, TableView },
	components: {
		SearchView,
		TableView,
		UserPopupView,
		partMngPopup
		// ,pqPartPopup
	},
	methods: {
		PopupOpen(param) {
			//this.userName = param.userName;
			//console.log('ContentView 에서의 this.userName 값 ::::: ', param.userName);
			// alert(this.$refs.searchView.userName);
			//this.$refs.searchView.open(param);
			// this.userName = param.userName;

			this.$refs.userPopupView.open(param); //.open(param);
		},
		sendData(param) {
			alert('console에서 데이터를 확인해 주세요!!', param);
		},
		SetName(param) {
			//console.log('@@@@ emit call');
			// console.log(param)
			// if (param != null) {
			// 	this.$refs.tableSection.setMenuName(param);
			// }
		},
		Refresh(currentPage = 1, pageUnit = 10) {
			this.$refs.UserPopupView.searchList(currentPage, pageUnit);
		},
		PqPartPopupOpen(param) {
			this.$refs.partMngPopup.open(param);
		},
		Refresh2(currentPage = 1, pageUnit = 10) {
			this.$refs.partMngPopup.searchPartList(currentPage, pageUnit);
		}
	}
};

//import SearchView from './Search/SearchView.vue';
//import TableView from './Table/TableInfoTable.vue';

/*
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components : {
		SearchView //, TableView
	}
	
	//components: { SearchView, TableView }
};
*/
</script>

<style></style>
